import { render, staticRenderFns } from "./RegisterStartup.vue?vue&type=template&id=5f89fe7a&"
import script from "./RegisterStartup.vue?vue&type=script&lang=js&"
export * from "./RegisterStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports